import { core } from "@tauri-apps/api";
import { useState, useEffect } from "react";

interface StepStreakData {
  is_birthday_today: boolean;
  streak_count: number;
}

/**
 * WHAT:
 *   Optimized Step Streak Hook that calls Tauri command directly.
 *
 * WHY:
 *   Calls the Tauri command directly for step streak data.
 *
 * @returns Object containing step streak data, loading state, error, and related fields
 *
 */
export const useOptimizedStepStreak = () => {
  const [data, setData] = useState<null | StepStreakData>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | string>(null);

  useEffect(() => {
    const fetchStepStreak = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await core.invoke<StepStreakData>("get_step_streak");
        setData(result);
      } catch (error_) {
        // [useOptimizedStepStreak] Error
        setError((error_ as Error).message);
      } finally {
        setLoading(false);
      }
    };

    void fetchStepStreak();
  }, []);

  return {
    error,
    is_birthday_today: data?.is_birthday_today ?? false,
    loading,
    steps: 0, // Not used in this context
    stepStreak: data,
    streak_count: data?.streak_count ?? 0,
    targetSteps: 10_000,
  };
};
